module.exports = __webpack_public_path__ + "static/media/PDF_48.3b552888.pdf";